<template>
  <div class="loading_Spin" v-if="showLoading" :style="{ width: width }">
    <div class="loading_one" v-if="showLoadingOne">
      <a-spin size="large" />
      <div class="loading_t">正在处理您的请求</div>
      <div>请稍后, 这个可能需要几秒钟</div>
    </div>
    <div class="loading_two" v-if="showLoadingTwo">
      <div class="loading_h"><a-icon type="info-circle" class="icon" />请完成必填项</div>
      <div class="loading_x">您尚未填写已下必填信息</div>
      <div class="loading_i">
        <div class="item" v-for="(item, index) in informationList" :key="index"><span></span> {{ item }}</div>
      </div>
      <div class="loading_f">请返回表单补充完整的信息</div>
      <div class="loading_f_b">
        <a-button type="danger" size="small" @click="handleBack"> 返回填写 </a-button>
      </div>
    </div>
    <!-- <div class="loading_two loading_three" v-if="showLoadThree">
        <div><a-icon type="info-circle" class="icon" /></div>
        <div class="loading_p">操作失败</div>
        <div class="loading_o">w无法完成您的请求，可能是由于网络链接问题，或者错误代码</div>
        <div class="loading_f_b">
          <a-button
            type="danger"
            size="small"
            @click="
              showLoadingTwo = false
              showLoading = false
            "
          >
            关闭
          </a-button>
        </div>
      </div> -->
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    width: {
      type: String,
      required: false,
      default: '35%',
    },
  },
  data() {
    return {
      showLoading: false,
      showLoadingOne: false,
      showLoadingTwo: false,
      informationList: [],
    }
  },
  methods: {
    handleBack() {
      this.showLoadingTwo = false
      //   this.showLoading = false
      this.$emit('ok')
    },
    init(e, arr) {
      this.showLoading = true
      if (e == 1) {
        this.showLoadingOne = true
      } else if (e == 2) {
        this.showLoadingTwo = true
        this.informationList = arr
      }
    },
  },
}
</script>
<style lang="less" scoped>
.loading_Spin {
  background: rgba(0, 0, 0, 0.6);
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
  .loading_one {
    width: 200px;
    height: 150px;
    background: #fff;
    border-radius: 20px;
    text-align: center;
    padding-top: 20px;
    .loading_t {
      font-size: 18px;
      font-weight: bold;
      color: #000;
      margin: 20px 0 10px;
    }
  }
  .loading_two {
    width: 250px;
    padding: 20px 8px;
    min-height: 150px;
    background: #fff;
    border-radius: 20px;
    .loading_h {
      display: flex;
      align-items: center;
      color: #000;
      font-size: 16px;
      font-weight: bold;
      .icon {
        margin-right: 15px;
        color: #ef4444;
      }
    }
    .loading_x {
      padding-left: 30px;
      font-size: 13px;
    }
    .loading_i {
      font-size: 12px;
      padding-left: 30px;
      color: #ef4444;
      span {
        display: inline-block;
        width: 5px;
        height: 5px;
        border-radius: 50%;
        background: #ef4444;
      }
      .item {
        margin: 5px 0;
      }
    }
    .loading_f {
      font-size: 13px;
      padding: 8px 0;
      padding-left: 30px;
      border-top: 1px solid #eee;
      border-bottom: 1px solid #eee;
      // position: absolute;
    }
    .loading_f_b {
      // widt
      padding: 10px 0 0;
      text-align: right;
    }
  }
  .loading_three {
    text-align: center;
    text-align: center;
    .icon {
      color: #ef4444;
    }
    .loading_p {
      font-size: 20px;
      color: #000;
      font-weight: bold;
    }
    .loading_o {
      text-align: left;
      margin-top: 10px;
    }
  }
}
</style>
